import { defineStore } from 'pinia';
import { getCountriesList, getPopularArticles, getEditorialSections } from '@/shared/api/experience';
import type { Article, GeoItem } from '@/shared/models/journal';
import { normalizeArticle } from './transforms';

export const useJournalStore = defineStore('journal', {
  state: () => ({
    countries: [] as GeoItem[],
    articles: [] as Article[],
    size: 5,
    popularArticleReqSize: 15,
    isViewButton: false,
    isLoadingCountries: false,
    isLoading: false,
    editorialArticles: [] as Article[],
    editorialTitle: '',
  }),
  actions: {
    async getCountries() {
      let response;

      this.isLoadingCountries = true;

      try {
        response = await getCountriesList({ query: { profitability: true } });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        this.isLoadingCountries = false;

        return;
      }

      const { data } = response;

      this.countries = data?.map((country) => ({ nameRu: country.name_ru, slug: country.slug })) ?? [];
      this.isLoadingCountries = false;
    },

    async getArticles() {
      if (this.articles.length || this.isLoading) {
        return;
      }

      let response;

      this.isLoading = true;
      try {
        response = await getPopularArticles({
          query: {
            sorting: '-date',
            page_size: this.popularArticleReqSize,
          },
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        this.isLoading = false;

        return;
      }

      this.articles = response.data?.results?.map((article) => normalizeArticle(article)) ?? [];
      this.isLoading = false;
    },
    async getEditorialArticles() {
      let response;

      this.isLoading = true;

      try {
        response = await getEditorialSections();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.debug(error);
        this.isLoading = false;

        return;
      }

      const { data } = response;

      if (!data || !data.length) {
        this.isLoading = false;

        return;
      }

      const firstSection = data[0];
      this.editorialArticles = firstSection.articles_data?.map((article) => normalizeArticle(article)) ?? [];
      this.editorialTitle = firstSection.title ?? '';
      this.isLoading = false;
    },
  },
});
